import React from "react";
import {
  Layout,
  Menu} from "antd";
import CommissionColumnMapping from "./CommissionColumnMapping";
import UploadCommession from "./UploadCommession";
const { Content } = Layout;
class CommissionCenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client_id: this.props.location.state,
      currentTab: "upload"
    };
  }
  getSelectedTabView() {
    // eslint-disable-next-line default-case
    switch (this.state.currentTab) {
      case "upload":
        return <UploadCommession client_id={this.state.client_id}/>
      case "map": {
        return <CommissionColumnMapping client_id={this.state.client_id} />
      }
    }
  }
  handleClick=(e)=>{
    
    this.setState({
      currentTab:e.key
    })
  }
  render() {
    return (
      <Content>
        <div className="mi_main_div">
          <Menu className="mi_general_bar" style={{  width: 'fit-content',marginLeft:'10px',marginRight:'10px' }}
            onClick={this.handleClick}
            selectedKeys={[this.state.currentTab]}
            mode="horizontal"
          >
            <Menu.Item className="mi_menu_item" key="upload">
              Upload Commission
            </Menu.Item>

            <Menu.Item className="mi_menu_item" key="map" >
              Commission Mapping
            </Menu.Item>
          </Menu>


          {this.getSelectedTabView()}
        </div>
      </Content>
    );
  }
}
export default CommissionCenter;
